import ApiCaller from "api/apiCaller";
import "./index.scss";
import SiteRevenueTable from "components/SiteRevenueTable";
import React, { useEffect, useState } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";
import { Container } from "reactstrap";
import { Button } from "shared";
import Loading from "components/Loading";
import ModalAddRevenue from "components/ModalAddRevenue";
import moment from "moment";

const Revenue = () => {
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [isOpenRevenue, setOpenRevenue] = useState(false);
  const toggleRevenue = () => setOpenRevenue(!isOpenRevenue);
  const history = useHistory();
  const match = useRouteMatch("/finance/revenue/:site_id");
  const params: any = match?.params;
  const siteId = params?.site_id;
  const [loading, setLoading] = useState(false);
  const [siteData, setSiteData] = useState<any>(null);
  const [revenueData, setRevenueData] = useState([]);
  const fetchSiteData = async () => {
    setLoading(true);
    const res = await ApiCaller.get(`site/${siteId}`);
    setSiteData(res?.result);
    setLoading(false);
  };
  const fetchData = async () => {
    const res = await ApiCaller.get(`site_revenue/site/${siteId}`);
    setRevenueData(res?.site_revenues || []);
  };
  useEffect(() => {
    if (siteId) {
      fetchSiteData();
      fetchData();
    }
  }, [siteId]);
  const onSaveRevenue = async (data: any) => {
    const body: any = {
      month_year: moment(data.month_year).format("YYYY-MM"),
      revenue_value: parseInt(data.revenue_value),
      month_year_start_date: data.month_year,
    };
    if (selectedItem) {
      body.id = selectedItem.id;
    }
    const res = await ApiCaller.post(`site_revenue/site/${siteId}`, body);
    if (res.status === "ok") {
      toggleRevenue();
      fetchData();
    } else {
      alert(res.message);
    }
  };
  const onEdit = (row: any) => {
    setSelectedItem(row);
    toggleRevenue();
  };
  const onDelete = async (row: any) => {
    const r = window.confirm(
      `Are you sure to delete revenue at ${row.month_year}?`
    );
    if (r) {
      const res = await ApiCaller.delete(`site_revenue/${row.id}`);
      if (res.status === "ok") {
        fetchData();
      } else {
        alert(res.message);
      }
    }
  };
  if (loading) return <Loading />;
  return (
    <Container style={{ height: "100%" }}>
      <div className="site-revenue__container">
        <div className="page-header">
          <div className="head-info">
            <span className="page-title">{siteData?.name}</span>
            <span className="page-description">
              Địa chỉ:{" "}
              <span className="page-description-value">
                {siteData?.full_address}
              </span>
            </span>
          </div>
          <div className="page-action">
            <Button
              label="Điền doanh thu CH"
              type="primary"
              onClick={() => {
                setSelectedItem(null);
                toggleRevenue();
              }}
            />
          </div>
        </div>
        <div className="page-body">
          {revenueData?.length > 0 && (
            <SiteRevenueTable
              data={revenueData}
              onDelete={onDelete}
              onEdit={onEdit}
            />
          )}
        </div>
      </div>
      <ModalAddRevenue
        open={isOpenRevenue}
        toggle={toggleRevenue}
        onSave={onSaveRevenue}
        selectedItem={selectedItem}
      />
    </Container>
  );
};

export default Revenue;
